import { IsUUID } from 'class-validator';

export class PutResidentServiceProvidersDto {
  @IsUUID('4', { each: true })
  globalServiceProviders!: string[];
}
